import { TAGS_REDUCER_KEYS as KEYS } from '../reducers/tagsReducerKeys'

export const projectTagsMapSelector = state => state.getIn([KEYS.REDUCER, KEYS.PROJECT_TAGS_BY_NAME])
export const itemTagsMapSelector = state => state.getIn([KEYS.REDUCER, KEYS.ITEM_TAGS_BY_NAME])
